<template>
  <div class="h-dialogContainer">
    <form id="reUploadTaskDialog">
      <div class="row h-row-inputBox">
        <div class="col-sm-12 h-col-inputBox">
          <div class="h-inputLit">{{$t('Pm.uploadBeginTime')}}:</div>
          <ejs-datetimepicker
            format='yyyy-MM-dd HH:mm:ss'
            timeFormat='HH:mm:ss'
            step="15"
            :allowEdit=false
            :change="validateOfReUploadDialog"
            name="reUploadFileStartTime"
            :locale='locale'
            v-model='reUploadFileStartTime'
          ></ejs-datetimepicker>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import {FormValidator} from "@syncfusion/ej2-vue-inputs";

  export default {
    name: 'UploadNoRealTaskDialog',
    data() {
      return {
        locale: localStorage.getItem('locale'),
        reUploadFileStartTime: null,
        reUploadValidation: {
          customPlacement(inputElement, errorElement) {
            errorElement.style.position = 'fixed';
            inputElement.parentElement.parentElement.appendChild(errorElement);
          },
          rules: {
            reUploadFileStartTime: {
              required: [true, this.$t('Pm.pleaseSelectUploadBeginTime')],
              regex: [/^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/, this.$t('Pm.uploadBeginTimeError')]
            }
          }
        },
        formObjOfReUploadDialog: ''
      }
    },
    methods: {
      bindValidateOfReUploadDialog(){
        this.formObjOfReUploadDialog = new FormValidator('#reUploadTaskDialog', this.reUploadValidation);
      },
      validateOfReUploadDialog() {
        const formStatus = this.formObjOfReUploadDialog.validate();
        if (!formStatus) {
          return false;
        }
        return true;
      },
    },
    mounted() {
      this.bindValidateOfReUploadDialog();
    }
  }
</script>

<style scoped>
</style>
